import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useThemeColor } from '../../hooks/useThemeColor';
import { login } from '../../api/Auth';
import { storeToken } from '../../utils/Auth';

export const LoginForm = () => {
  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    setLoading(true);
    login(email, password)
      .then((token) => {
        toast.success('Başarıyla giriş yapıldı');
        storeToken(token);
        navigate('/');
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Paper
      elevation={3}
      sx={{
        px: 2.5,
        py: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
        Giriş Yap
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>E-Posta</Typography>

        <TextField
          size='small'
          fullWidth
          disabled={loading}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>Şifre</Typography>
        <TextField
          size='small'
          fullWidth
          disabled={loading}
          type={showPassword ? undefined : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Link
          to='/sifremi-unuttum'
          style={{
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
          }}
        >
          <Typography>Şifreni mi unuttun?</Typography>
        </Link>

        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                size='small'
                checked={showPassword}
                onChange={() => setShowPassword((x) => !x)}
              />
            }
            label={
              <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                Şifreyi Göster
              </Typography>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                size='small'
                checked={rememberMe}
                onChange={() => setRememberMe((x) => !x)}
              />
            }
            label={
              <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                Beni Hatırla
              </Typography>
            }
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Button
          variant='contained'
          onClick={handleLogin}
          disabled={loading}
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
          }}
        >
          Giriş Yap
        </Button>

        {loading && <CircularProgress color='primary' />}
      </Box>
    </Paper>
  );
};
